"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneVerificationInDepositInput = void 0;
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components/");
var react_final_form_1 = require("react-final-form");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var PhoneVerificationInDepositInput = function (_a) {
    var _b, _c;
    var values = _a.values, onModalOpen = _a.onModalOpen, isPhoneVerified = _a.isPhoneVerified, country = _a.country;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var tPhone = (0, next_intl_1.useTranslations)('phoneVerification');
    var data = (0, swr_hooks_1.useUser)().data;
    var formState = (0, react_final_form_1.useFormState)();
    var _d = (0, react_1.useState)(null), errorPhoneUpdate = _d[0], setErrorPhoneUpdate = _d[1];
    var _e = (0, swr_hooks_1.useSendPhoneVerificationSms)({}), sendPhoneVerificationSms = _e.sendPhoneVerificationSms, isSubmitting = _e.isSubmitting;
    var updateProfile = (0, swr_hooks_1.useUpdateProfileData)({
        successAction: function () {
            if (values === null || values === void 0 ? void 0 : values.phone) {
                sendPhoneVerificationSms({
                    input: {
                        phone: values.phone,
                    },
                });
                onModalOpen === null || onModalOpen === void 0 ? void 0 : onModalOpen();
            }
        },
        errorAction: function (err) {
            setErrorPhoneUpdate(err);
        },
    }).updateProfile;
    var sendVerificationCode = (0, react_1.useCallback)(function () {
        updateProfile({
            phone: values === null || values === void 0 ? void 0 : values.phone,
        });
    }, [values === null || values === void 0 ? void 0 : values.phone, updateProfile]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isPhoneVerified ? styles_module_scss_1.default.verified : '', " ").concat(styles_module_scss_1.default.deposit) },
        react_1.default.createElement(react_final_form_1.Field, { name: "phone", render: function (_a) {
                var _b, _c;
                var input = _a.input, meta = _a.meta;
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(ui_components_1.PhoneInput, __assign({}, input, { countryCodeEditable: true, errors: meta.error && meta.touched, country: country
                            ? country
                            : !(values === null || values === void 0 ? void 0 : values.phone)
                                ? (_c = (_b = values === null || values === void 0 ? void 0 : values.country) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.toLowerCase()
                                : undefined, onChange: function (data) {
                            input.onChange(data);
                            if (errorPhoneUpdate)
                                setErrorPhoneUpdate(null);
                        }, placeholder: t('phone'), helperButton: isPhoneVerified
                            ? meta.error && meta.touched && { type: 'error' }
                            : undefined, tooltip: react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: t.raw('lockPersonalData'),
                            } }) })),
                    errorPhoneUpdate && (react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper },
                        react_1.default.createElement(ui_components_1.ErrorText, null, tErr("".concat(errorPhoneUpdate))))),
                    meta.error && meta.touched && (react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper },
                        react_1.default.createElement(ui_components_1.ErrorText, null, meta.error)))));
            } }),
        !isPhoneVerified && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.btnWrapper, " ") },
                react_1.default.createElement(ui_components_1.FixedButton, { height: "40px", width: "100%", type: "button", text: "upper", color: "gradient", maxWidth: "none", loading: isSubmitting, disabled: ((_b = formState.errors) === null || _b === void 0 ? void 0 : _b.phone) || !Boolean(((_c = values === null || values === void 0 ? void 0 : values.phone) === null || _c === void 0 ? void 0 : _c.length) >= 8), onClick: sendVerificationCode }, tPhone('verifyPhone')))))));
};
exports.PhoneVerificationInDepositInput = PhoneVerificationInDepositInput;
